import { monthNames } from "./constants/index.js";

const formatDate = (date) => date.toISOString().slice(0, 19);

export const calculateDates = (now = new Date(), offsetHours = null) => {
	const offset = offsetHours ?? -(now.getTimezoneOffset() / 60);
	const offsetMs = offset * 3_600_000;

	const applyOffset = (date) => {
		const newDate = new Date(date);
		newDate.setTime(newDate.getTime() + offsetMs);
		return newDate;
	};

	const year = now.getFullYear();
	const month = now.getMonth();

	const currentDateTime = applyOffset(now);
	const monthStart = applyOffset(new Date(year, month, 1));

	return {
		year,
		month,
		currentDate: formatDate(currentDateTime),
		formattedBeginningOfMonth: formatDate(monthStart),
	};
};

export const getCustomDateTime = (year, month) => {
	const date = new Date(year, month - 1);

	const currentDate = new Date();
	date.setDate(currentDate.getDate());
	date.setHours(currentDate.getHours());
	date.setMinutes(currentDate.getMinutes());
	date.setSeconds(currentDate.getSeconds());
	date.setMilliseconds(currentDate.getMilliseconds());

	return date;
};

export const calculateDifferenceBetweenDates = (startDate, endDate) => {
	const start = new Date(startDate);
	const end = new Date(endDate);

	const differenceInTime = end - start;
	const differenceInDays = Math.ceil(differenceInTime / (1000 * 3600 * 24) + 1);
	const differenceInHours = Math.ceil(differenceInTime / (1000 * 3600));

	return { differenceInDays, differenceInHours };
};

export const getMonthDetails = (month, year) => {
	const paddedMonth = String(monthNames[month].no).padStart(2, "0");
	const lastDay = new Date(year, monthNames[month].no, 0).getDate();
	return {
		paddedMonth,
		lastDay,
		dateRange: {
			month,
			startDate: `${year}-${paddedMonth}-01`,
			endDate: `${year}-${paddedMonth}-${lastDay}`,
		},
	};
};